import React from 'react';

const AdminPillTabs = ({ tabs, active, onChange }) => (
  <div className="flex flex-wrap gap-2">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        onClick={() => onChange(tab.id)}
        className={`admin-pill ${active === tab.id ? 'admin-pill--active' : ''}`}
      >
        {tab.label}
        {tab.count != null && (
          <span className={active === tab.id ? 'opacity-80' : 'opacity-60'}>{tab.count}</span>
        )}
      </button>
    ))}
  </div>
);

export default AdminPillTabs;
